import {apiRequestWithAuth} from "@helpers/query/apiRequestWithAuth";
import {OnShowError} from "@baseTypes/base";
import {BASE_TRACK_API_URL} from "@constants/config";
import {
    BodySaveTaskTemplateSingleVoyage,
    DataTasksTemplateSingleVoyage,
    IBodyAddTaskTemplateSingleVoyage,
    IBodyUpdateTaskTemplateSingleVoyage,
    IPropsGetTasksTemplateSingleVoyage,
    ITaskTemplateSingleVoyage
} from "@containers/singleVoyage/taskTemplate/types";


const BASE_URL = `${BASE_TRACK_API_URL}/v1/accounts`

export const saveTaskTemplateSingleVoyage = async (
    body: BodySaveTaskTemplateSingleVoyage,
    onError?: OnShowError
): Promise<ITaskTemplateSingleVoyage> => {
    if ('id' in body && body.id) {
        return updateTaskTemplateSingleVoyage(body, onError)
    }
    return addTaskTemplateSingleVoyage(body, onError)

}

export const addTaskTemplateSingleVoyage = async (
    {
        accountId,
        ...body
    }: IBodyAddTaskTemplateSingleVoyage,
    onError?: OnShowError
): Promise<ITaskTemplateSingleVoyage> => {
    const url = `${BASE_URL}/${accountId}/single-voyages/tasks/config-templates`
    return await apiRequestWithAuth<ITaskTemplateSingleVoyage>({
        url,
        options: {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                'Content-type': 'application/json'
            }

        },
        onError
    });

}

export const updateTaskTemplateSingleVoyage = async ({
                                                         accountId,
                                                         id,
                                                         ...body
                                                     }: IBodyUpdateTaskTemplateSingleVoyage,
                                                     onError?: OnShowError
): Promise<ITaskTemplateSingleVoyage> => {
    const url = `${BASE_URL}/${accountId}/single-voyages/tasks/config-templates/${id}`
    return await apiRequestWithAuth<ITaskTemplateSingleVoyage>({
        url,
        options: {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {
                'Content-type': 'application/json'
            }

        },
        onError
    });

}


export const getTasksTemplateSingleVoyage = async (
    {accountId}: IPropsGetTasksTemplateSingleVoyage,
    onError?: OnShowError
): Promise<DataTasksTemplateSingleVoyage> => {
    const url = `${BASE_URL}/${accountId}/single-voyages/tasks/config-templates`
    return await apiRequestWithAuth<DataTasksTemplateSingleVoyage>({
        url,
        options: {
            method: "GET",
        },
        onError
    });

}
